module.exports = __webpack_public_path__ + "img/logo--seo-team-flow.316761f5.png";